import { useEffect, useState } from "react";

const navItems = [
  { label: "今日热榜", href: "#hot", icon: "ri-fire-fill" },
  { label: "分类速递", href: "#feeds", icon: "ri-archive-drawer-line" },
  { label: "深度盘点", href: "#feature", icon: "ri-newspaper-line" },
  { label: "今日瓜历", href: "#timeline", icon: "ri-time-line" },
  { label: "关于我们", href: "#about", icon: "ri-heart-line" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="w-full">
      <div className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70" : "bg-transparent"}`}>
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜网上 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl tracking-wide text-foreground-950">
                吃瓜<span className="text-primary-600">网上</span>
              </span>
            </a>

            <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="flex items-center gap-1.5 rounded-full px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                  {item.label}
                </a>
              ))}
            </nav>

            <div className="flex items-center gap-3">
              <a
                href="#hot"
                className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-focus-3-line" aria-hidden="true"></i>
                看今日瓜
              </a>
              <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                aria-label="打开菜单"
                aria-expanded={open}
                className="flex md:hidden h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-800 cursor-pointer"
              >
                <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>

        {open && (
          <nav className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur px-4 py-3 space-y-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 rounded-xl px-4 py-3 text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <i className={`${item.icon} text-lg text-primary-600`} aria-hidden="true"></i>
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}